"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PresetColors", {
  enumerable: true,
  get: function () {
    return _presetColors.PresetColors;
  }
});
var _presetColors = require("./presetColors");